export default {"src":"/_next/static/media/icon-bungalows.88c0fbd3.svg","height":21,"width":30,"blurWidth":0,"blurHeight":0};